import {Directive, ElementRef, NgZone, OnDestroy, OnInit} from '@angular/core';

/** Row hover for DualAxisComponent's grid layout. A grid row's cells live in three
 *  containers (left pin, middle, right pin), so no element spans the row and
 *  tr:hover has no equivalent; this marks every cell sharing the hovered cell's
 *  data-row with .row-hover instead. Runs outside the Angular zone: hovering
 *  changes no component state. */
@Directive({
    selector: '[GridRowHover]',
    standalone: false
})
export class GridRowHoverDirective implements OnInit, OnDestroy {

  /** The hovered cell element, not its data-row: rows are tracked by id, so a
   *  hide or re-sort keeps the elements and renumbers them under the pointer. */
  private cell: HTMLElement = null;

  private readonly overHandler = (event: MouseEvent) =>
    this.mark((<HTMLElement>event.target).closest<HTMLElement>('[data-row]'));
  private readonly leaveHandler = () => this.mark(null);

  constructor(private host: ElementRef<HTMLElement>, private zone: NgZone) {
  }

  ngOnInit() {
    this.zone.runOutsideAngular(() => {
      this.host.nativeElement.addEventListener('mouseover', this.overHandler);
      this.host.nativeElement.addEventListener('mouseleave', this.leaveHandler);
    });
  }

  ngOnDestroy() {
    this.host.nativeElement.removeEventListener('mouseover', this.overHandler);
    this.host.nativeElement.removeEventListener('mouseleave', this.leaveHandler);
  }

  private mark(cell: HTMLElement) {
    if (cell === this.cell) {
      return;
    }
    this.query('.row-hover').forEach(c => c.classList.remove('row-hover'));
    if (cell) {
      this.query(`[data-row="${cell.dataset['row']}"]`).forEach(c => c.classList.add('row-hover'));
    }
    this.cell = cell;
  }

  private query(selector: string): HTMLElement[] {
    return Array.from(this.host.nativeElement.querySelectorAll<HTMLElement>(selector));
  }

}
